/*
*   search popup
*/

var functions = window.nffleet_functions;
var events = window.nffleet_events;

var searchBtn = document.getElementById("search-btn");

searchBtn.addEventListener("click", function () {
    this.blur();
    
    var divTag = "div";
    var buttonTag = "button";

    var searchWrapper = functions.getPopUpWrapperWithBackground();

    var searchContainer = document.createElement(divTag);
    searchContainer.classList.add("mfp-container");
    searchContainer.classList.add("mfp-s-ready");
    searchContainer.classList.add("mfp-inline-holder");
    searchWrapper.appendChild(searchContainer);

    var searchContent = document.createElement(divTag);
    searchContent.classList.add("mfp-content");
    searchContainer.appendChild(searchContent);

    var searchContentContainer = document.createElement(divTag);
    searchContentContainer.id = "search";
    searchContentContainer.classList.add("max-width-3");
    searchContentContainer.classList.add("centered");
    searchContent.appendChild(searchContentContainer);

    var searchFormWrapper = window.nffleet_searchForm(this.getAttribute('data-input-placeholder'));
    searchContentContainer.appendChild(searchFormWrapper);

    var searchInputField = document.getElementById("search-input-field");
    searchInputField.focus();

    var closeButton = document.createElement(buttonTag);
    closeButton.title = "Close (ESC)";
    closeButton.type = "button";
    closeButton.classList.add("mfp-close");
    closeButton.innerHTML = "×";
    searchContentContainer.appendChild(closeButton);

    searchFormWrapper.addEventListener("destroy", function () {
        destroyPopup();
    });

    searchWrapper.addEventListener("click", function (event) {
        if (event.target !== searchContentContainer && !searchContentContainer.contains(event.target)) {
            destroyPopup();
        }
    });

    closeButton.addEventListener("click", destroyPopup);

    function destroyPopup() {
        searchWrapper.dispatchEvent(events.destroy());
    }
});